<script>
import * as moment from 'moment'

export default {
  props: {
    overwriteType: String,
    overwriteDate: String,
  },

  data: function () {
    return {
      date: moment().format('YYYY-MM-DD'),
      amountKg: '',
      totalRands: '',
      siloIsEmpty: false,
    };
  },

  computed: {
    validationError() {
      if (!this.date) return 'Please choose a Date';
      if (!this.siloIsEmpty && (isNaN(this.amountKg) || Number(this.amountKg) === 0)) return 'Please enter an Amount';
      if (!this.siloIsEmpty && (isNaN(this.totalRands) || Number(this.totalRands) === 0)) return 'Please enter the Total Cost';

      return undefined;
    },

    submitPayload() {
      return {
        date: this.date,
        operation: this.siloIsEmpty ? 'reset' : 'add',
        amount_kg: this.siloIsEmpty ? 0 : Number(this.amountKg),
        total_cost_rand: this.siloIsEmpty ? 0 : Number(this.totalRands),
      };
    },
  },

  methods: {
    doFormatDate(date, format) { return moment(date).format(format) },

    onFormSubmitSuccess(feedRecord) {
      this.$emit('added', feedRecord);
      this.clearForm();
    },

    onCancelledForm() {
      this.$emit('cancel');
    },

    clearForm() {
      this.date = moment().format('YYYY-MM-DD');
      this.amountKg = '';
      this.totalRands = '';
      this.siloIsEmpty = false;
    },
  },
}
</script>

<template>

  <api-form
    method="post"
    url="v1/layeradmin/feed-records"
    :payload="submitPayload"
    submit-text="Add"
    :validation-error="validationError"
    :make-success-message="(feedRecord) => `Successfully added pellet food on ${doFormatDate(feedRecord.date, 'YYYY-MM-DD')}`"
    @success="onFormSubmitSuccess"
    @cancel="onCancelledForm">

    <h4 class="text-center mt-0">Add Feed Record</h4>

    <b-form-group label="Date" :label-for="`date-${_uid}`">
      <b-form-input :id="`date-${_uid}`"
        v-model="date"
        type="date"
        placeholder="Date..."
        required
        @focus="$event.target.select()" />
    </b-form-group>

    <b-form-group label="Amount" :label-for="`amount-${_uid}`">
      <b-input-group append="kg">
        <b-form-input :id="`amount-${_uid}`"
          v-model="amountKg"
          type="number"
          step="any"
          :required="!siloIsEmpty"
          :disabled="siloIsEmpty"
          @focus="$event.target.select()" />
      </b-input-group>
    </b-form-group>

    <b-form-group label="Total Cost" :label-for="`cost-${_uid}`" class="mb-0">
      <b-input-group prepend="R">
        <b-form-input :id="`cost-${_uid}`"
          v-model="totalRands"
          type="number"
          step="any"
          :required="!siloIsEmpty"
          :disabled="siloIsEmpty"
          @focus="$event.target.select()" />
      </b-input-group>
    </b-form-group>

    <div class="mt-1 mb-4">
      <b-form-checkbox v-model="siloIsEmpty">Silo is empty</b-form-checkbox>
    </div>

  </api-form>

</template>



// WEBPACK FOOTER //
// src/layerAdmin/components/FoodAddPelletRecord.vue